import { Tag } from "antd";
import { segmentStatus, statusLabel, type Segment, type SegmentStatus } from "@/data/catalog";

const COLORS: Record<SegmentStatus, string> = {
  ACTIVE: "green",
  PENDING: "orange",
  INACTIVE: "default",
};

export function StatusTag({ segment }: { segment: Segment }) {
  const status = segmentStatus(segment);
  return <Tag color={COLORS[status]}>{statusLabel(status)}</Tag>;
}

export function StatusLabel({ status }: { status: SegmentStatus }) {
  return <Tag color={COLORS[status]}>{statusLabel(status)}</Tag>;
}
